import MainSharedComponent, {
    MainImgTextSharedComponentElType,
} from "@components/severalbrands/ourStoryPage/mainSharedComponent";
import OurApproach, { OurApproachItem } from "./ourApproach";
const defaultSecondSectionInfo: MainImgTextSharedComponentElType = {
    img: "/severalbrands/assets/images/boostingClientAcquisitionImg.png",
    mainTitle: "Enhancing Client Intake for MVA Lawyers",

    paragraphs: [
        "Motor vehicle accident (MVA) lawyers often face significant challenges in client acquisition, with over 50% of law firms reporting difficulties in this area. High costs and the need to juggle multiple responsibilities, especially for solo practitioners and small firms, contribute to this struggle.",
        "At Several Brands, we specialize in generating high-quality leads for MVA lawyers through clear, educational content and targeted ads. Our approach ensures that your legal services are visible to the right audience, leading to higher conversion rates and a more efficient client intake process. By partnering with us, MVA lawyers can focus on their core practice while we handle the complexities of client acquisition, ultimately driving down costs and boosting profitability.",
    ],

    mainSectionClassName: `3xl:gap-[200px] lg:gap-16 gap-[40px] `,
    mainTitleClassName: "text-[#351C4F]",

    imgClassName:
        "w-[285px]  h-[240px] md:w-[650px] md:min-w-[650px] md:h-[550px] relative 3xl:w-[750px] 3xl:min-w-[750px] 3xl:h-[650px] 3xl:mt-16  ",
};

export interface SecondSectionLegalProps {
    mainInfo?: MainImgTextSharedComponentElType;
    approach?: {
        title?: string;
        list?: OurApproachItem[];
    };
}

export default function SecondSection({
    mainInfo = defaultSecondSectionInfo,
    approach,
}: SecondSectionLegalProps) {
    return (
        <section className="3xl:mt-52  lg:mt-28 mt-14">
            <MainSharedComponent info={mainInfo} />
            <OurApproach title={approach?.title} list={approach?.list} />
        </section>
    );
}
